import { render } from "./welcome.vue?vue&type=template&id=73dce1f8"
import script from "./welcome.vue?vue&type=script&lang=ts"
export * from "./welcome.vue?vue&type=script&lang=ts"
script.render = render

export default script